import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartVennDiagram"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 4.5C13.9671 4.49948 12.9454 4.71403 12 5.13C11.0546 4.71403 10.0329 4.49948 9 4.5C4.85786 4.5 1.5 7.85786 1.5 12C1.5 16.1421 4.85786 19.5 9 19.5C10.0329 19.5005 11.0546 19.286 12 18.87C12.9454 19.286 13.9671 19.5005 15 19.5C19.1421 19.5 22.5 16.1421 22.5 12C22.5 7.85786 19.1421 4.5 15 4.5ZM9 18C5.68629 18 3 15.3137 3 12C3 8.68629 5.68629 6 9 6C9.44423 6.00042 9.887 6.05074 10.32 6.15C8.54571 7.57348 7.51335 9.72528 7.51335 12C7.51335 14.2747 8.54571 16.4265 10.32 17.85C9.887 17.9493 9.44423 17.9996 9 18ZM14.9999 12C14.9977 14.1414 13.8544 16.1193 11.9999 17.19C10.1495 16.1166 9.01051 14.1392 9.01051 12C9.01051 9.86081 10.1495 7.88341 11.9999 6.81001C13.8544 7.88071 14.9977 9.85862 14.9999 12ZM14.9999 18C14.5557 17.9996 14.1129 17.9493 13.6799 17.85C15.4542 16.4265 16.4866 14.2747 16.4866 12C16.4866 9.72528 15.4542 7.57348 13.6799 6.15C14.1129 6.05074 14.5557 6.00042 14.9999 6C18.3137 6 20.9999 8.68629 20.9999 12C20.9999 15.3137 18.3137 18 14.9999 18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartVennDiagram.vue"]]);
